(function() {
  'use strict';

  function getTiersForProductCached(productHandle) {
    var byProduct = (window.BulkOrderPage && window.BulkOrderPage.tiersByProduct) ? window.BulkOrderPage.tiersByProduct : {};
    var tiers = byProduct[productHandle];
    return Array.isArray(tiers) ? tiers : null;
  }

  function fetchTiersForProduct(productHandle) {
    var cached = getTiersForProductCached(productHandle);
    if (cached !== null) return Promise.resolve(cached);

    return fetch('/products/' + productHandle + '?section_id=bulk-tier-data')
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var match = html.match(/<script[^>]*data-bulk-tier-data[^>]*>([\s\S]*?)<\/script>/);
        var tiers = [];
        if (match && match[1]) {
          try { tiers = JSON.parse(match[1].trim()); } catch(e) { tiers = []; }
        }
        if (!Array.isArray(tiers)) tiers = [];
        window.BulkOrderPage = window.BulkOrderPage || {};
        window.BulkOrderPage.tiersByProduct = window.BulkOrderPage.tiersByProduct || {};
        window.BulkOrderPage.tiersByProduct[productHandle] = tiers;
        return tiers;
      })
      .catch(function() { return []; });
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function getOptionName(product, index) {
    if (product.options && product.options[index]) return product.options[index];
    return 'Option ' + (index + 1);
  }

  function initBulkOrderPage(section) {
    if (!section) return;
    var container = section.closest ? section : document.getElementById(section);
    if (!container) return;

    var productPicker = container.querySelector('[data-product-picker]');
    var productList = container.querySelector('[data-product-list]');
    var builder = container.querySelector('[data-builder]');
    var productSummary = container.querySelector('[data-product-summary]');
    var tierCards = container.querySelector('[data-tier-cards]');
    var variantRows = container.querySelector('[data-variant-rows]');
    var variantsWrap = container.querySelector('[data-variants-wrap]');
    var variantsToggle = container.querySelector('[data-variants-toggle]');
    var addRowBtn = container.querySelector('[data-add-variant-row]');
    var totalLine = container.querySelector('[data-total-line]');
    var errorsEl = container.querySelector('[data-errors]');
    var addToCartBtn = container.querySelector('[data-add-to-cart]');
    var emptyState = container.querySelector('[data-empty-state]');

    var state = {
      collectionHandle: null,
      collectionTitle: null,
      products: [],
      product: null,
      tiers: [],
      variantRowsCount: parseInt(container.getAttribute('data-default-rows') || '5', 10)
    };

    function showError(msg) {
      if (!errorsEl) return;
      errorsEl.textContent = msg || '';
      errorsEl.style.display = msg ? 'block' : 'none';
    }

    function setEmpty(empty) {
      if (emptyState) emptyState.setAttribute('aria-hidden', !empty);
      if (productPicker) productPicker.setAttribute('aria-hidden', empty);
      if (builder) builder.setAttribute('aria-hidden', !empty);
    }

    function activateTab(tab) {
      var tabs = container.querySelectorAll('.bulk-order-page__collection-tab');
      tabs.forEach(function(t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
    }

    function loadCollectionProducts(handle, title) {
      state.collectionHandle = handle;
      state.collectionTitle = title;
      state.product = null;
      state.tiers = [];

      setEmpty(false);
      if (productList) productList.innerHTML = '<p class="bulk-order-page__loading">Loading…</p>';
      if (builder) builder.setAttribute('aria-hidden', 'true');

      fetch('/collections/' + handle + '/products.json?limit=50')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          state.products = data.products || [];
          renderProductList();
        })
        .catch(function() {
          if (productList) productList.innerHTML = '<p class="bulk-order-page__error">Could not load products.</p>';
        });
    }

    function getProductImageUrl(p, size) {
      var src = '';
      if (typeof p.featured_image === 'string' && p.featured_image) {
        src = p.featured_image;
      } else if (p.featured_image && p.featured_image.src) {
        src = p.featured_image.src;
      } else if (p.image && typeof p.image === 'string') {
        src = p.image;
      } else if (p.image && p.image.src) {
        src = p.image.src;
      } else if (p.images && p.images.length > 0) {
        var first = p.images[0];
        src = typeof first === 'string' ? first : (first.src || '');
      }
      if (!src) return '';
      if (size) src = src.replace(/\.([^.]*)$/, '_' + size + '.$1');
      return src;
    }

    function renderProductList() {
      if (!productList) return;
      if (state.products.length === 0) {
        productList.innerHTML = '<p>No products in this collection.</p>';
        return;
      }
      productList.innerHTML = state.products.map(function(p) {
        var imgUrl = getProductImageUrl(p, 'medium');
        var img = imgUrl ? '<img src="' + imgUrl + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy">' : '';
        return '<button type="button" class="bulk-order-page__product-card" data-product-handle="' + (p.handle || '') + '">' +
          '<span class="bulk-order-page__product-card-image">' + img + '</span>' +
          '<span class="bulk-order-page__product-card-title">' + (p.title || '') + '</span>' +
          '</button>';
      }).join('');

      productList.querySelectorAll('.bulk-order-page__product-card').forEach(function(btn) {
        btn.addEventListener('click', function() {
          selectProduct(btn.getAttribute('data-product-handle'));
        });
      });
    }

    function selectProduct(handle) {
      if (!handle) return;
      state.product = null;
      if (productSummary) productSummary.innerHTML = '<p class="bulk-order-page__loading">Loading…</p>';
      if (tierCards) tierCards.innerHTML = '';
      if (variantRows) variantRows.innerHTML = '';
      if (variantsWrap) variantsWrap.setAttribute('aria-hidden', 'true');
      if (addToCartBtn) addToCartBtn.disabled = true;
      showError('');

      Promise.all([
        fetch('/products/' + handle + '.json').then(function(r) { return r.json(); }),
        fetchTiersForProduct(handle)
      ])
        .then(function(results) {
          var productData = results[0];
          var product = productData.product || productData;
          var tiers = results[1];
          state.product = product;
          state.tiers = Array.isArray(tiers) ? tiers : [];
          renderProductSummary();
          renderTierCards();
          renderVariantRows();
          if (builder) builder.setAttribute('aria-hidden', 'false');
          if (variantsWrap) variantsWrap.setAttribute('aria-hidden', 'false');
          updateTotalAndButton();
          setTimeout(function() {
            if (builder) {
              var isMobile = window.innerWidth <= 768;
              var offset = isMobile ? -10 : -80;
              var target = isMobile ? (container.querySelector('.bulk-order-page__product-summary') || builder) : (container.querySelector('.bulk-order-page__product-summary') || builder);
              var top = target.getBoundingClientRect().top + window.pageYOffset + offset;
              window.scrollTo({ top: top, behavior: 'smooth' });
            }
          }, 100);
        })
        .catch(function() {
          if (productSummary) productSummary.innerHTML = '<p class="bulk-order-page__error">Could not load product.</p>';
        });
    }

    function renderProductSummary() {
      if (!productSummary || !state.product) return;
      var p = state.product;
      var priceDollars = p.variants && p.variants[0] ? parseFloat(p.variants[0].price) : 0;
      var priceCents = Math.round(priceDollars * 100);
      var imgUrl = getProductImageUrl(p, 'large');
      var img = imgUrl ? '<img class="bulk-order-page__product-image" src="' + imgUrl + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy">' : '';
      productSummary.innerHTML = (img ? '<div class="bulk-order-page__product-image-wrap">' + img + '</div>' : '') +
        '<h2 class="bulk-order-page__product-title">' + (p.title || '') + '</h2>' +
        '<p class="bulk-order-page__product-price">' + formatMoney(priceCents) + '</p>';
    }

    function renderTierCards() {
      if (!tierCards || !state.product) return;
      var tiers = state.tiers;
      var basePrice = state.product.variants && state.product.variants[0] ? parseFloat(state.product.variants[0].price) : 0;

      if (tiers.length === 0) {
        tierCards.innerHTML = '<p class="bulk-order-page__no-tiers">No bulk tiers for this product.</p>';
        return;
      }

      var rows = tiers.map(function(tier, i) {
        var min = tier.min != null ? tier.min : 0;
        var percent = tier.percent != null ? tier.percent : 0;
        var pricePerUnit = basePrice * (1 - percent / 100);
        var pricePerUnitCents = Math.round(pricePerUnit * 100);
        return '<tr data-tier-row="' + i + '">' +
          '<td>Buy ' + min + '+</td>' +
          '<td>' + formatMoney(pricePerUnitCents) + '</td>' +
          '<td>' + percent + '%</td>' +
          '</tr>';
      }).join('');

      tierCards.innerHTML = '<table class="bulk-order-page__tier-table">' +
        '<thead><tr><th>Minimum Qty</th><th>Price Per Item</th><th>Discount</th></tr></thead>' +
        '<tbody>' + rows + '</tbody></table>';
    }

    function highlightActiveTier(qty) {
      if (!tierCards) return;
      var rows = tierCards.querySelectorAll('[data-tier-row]');
      var tiers = state.tiers;
      var activeIndex = -1;
      for (var i = 0; i < tiers.length; i++) {
        var t = tiers[i];
        if (t.sold_out) continue;
        if (qty >= (t.min || 0) && (t.max == null || qty <= t.max)) {
          if (activeIndex === -1 || (t.percent != null && t.percent > (tiers[activeIndex].percent || 0))) {
            activeIndex = i;
          }
        }
      }
      rows.forEach(function(row) {
        var idx = parseInt(row.getAttribute('data-tier-row'), 10);
        row.classList.toggle('is-active', idx === activeIndex);
      });
    }

    function renderVariantRows() {
      if (!variantRows || !state.product) return;
      var p = state.product;
      var isPreorder = (p.tags || []).indexOf('preorder') !== -1;
      var optionName = 'Size';
      var count = state.variantRowsCount;

      variantRows.innerHTML = '';
      for (var i = 0; i < count; i++) {
        appendVariantRow(optionName, isPreorder);
      }
      if (addRowBtn) {
        addRowBtn.onclick = function() { appendVariantRow(optionName, isPreorder); };
      }
      updateTotalAndButton();
    }

    function getVariantStock(variantId) {
      var variants = state.product ? state.product.variants || [] : [];
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(variantId)) return variants[i];
      }
      return null;
    }

    function appendVariantRow(optionName, isPreorder) {
      if (!variantRows || !state.product) return;
      var p = state.product;
      var variants = p.variants || [];
      var row = document.createElement('div');
      row.className = 'bulk-order-page__variant-row';
      var optionsHtml = variants.map(function(v) {
        var label = v.option1 || v.title || 'Variant ' + v.id;
        var soldOut = !isPreorder && (
          v.available === false ||
          (v.inventory_quantity !== undefined && v.inventory_quantity <= 0 && v.available !== true)
        );
        if (soldOut) label += ' — Sold out';
        return '<option value="' + v.id + '"' + (soldOut ? ' disabled' : '') + '>' + label + '</option>';
      }).join('');
      row.innerHTML = '<span class="bulk-order-page__variant-row-num"></span>' +
        '<select class="bulk-order-page__variant-select" data-variant-id aria-label="' + optionName + '">' +
        '<option value="">— Select —</option>' + optionsHtml + '</select>' +
        '<input type="number" class="bulk-order-page__variant-qty" min="0" max="9999" value="0" data-variant-qty aria-label="Quantity">' +
        '<button type="button" class="bulk-order-page__variant-remove link" data-remove-row aria-label="Remove row">&times;</button>';
      variantRows.appendChild(row);
      updateRowNumbers();

      var qtyInput = row.querySelector('.bulk-order-page__variant-qty');
      qtyInput.addEventListener('input', function() {
        var val = parseInt(this.value, 10);
        if (isNaN(val) || val < 0) this.value = 0;
        else if (val > 9999) this.value = 9999;
        updateTotalAndButton();
      });
      row.querySelector('.bulk-order-page__variant-select').addEventListener('change', updateTotalAndButton);
      row.querySelector('[data-remove-row]').addEventListener('click', function() {
        if (variantRows.children.length > 1) {
          row.remove();
          updateRowNumbers();
          updateTotalAndButton();
        }
      });
    }

    function updateRowNumbers() {
      if (!variantRows) return;
      var rows = variantRows.querySelectorAll('.bulk-order-page__variant-row');
      rows.forEach(function(r, i) {
        var num = r.querySelector('.bulk-order-page__variant-row-num');
        if (num) num.textContent = '#' + (i + 1);
      });
    }

    function getLineItems() {
      var items = [];
      if (!variantRows) return items;
      variantRows.querySelectorAll('.bulk-order-page__variant-row').forEach(function(row) {
        var select = row.querySelector('[data-variant-id]');
        var qtyInput = row.querySelector('[data-variant-qty]');
        var variantId = select ? select.value : '';
        var qty = parseInt(qtyInput ? qtyInput.value : 0, 10);
        if (variantId && qty > 0) items.push({ id: parseInt(variantId, 10), quantity: qty });
      });
      return items;
    }

    function mergeLineItems(items) {
      var byId = {};
      items.forEach(function(item) {
        var id = item.id;
        byId[id] = (byId[id] || 0) + item.quantity;
      });
      var tiersJson = state.tiers && state.tiers.length ? JSON.stringify(state.tiers) : null;
      return Object.keys(byId).map(function(id) {
        var obj = { id: parseInt(id, 10), quantity: byId[id] };
        if (tiersJson) obj.properties = { _bulk_tiers: tiersJson };
        return obj;
      });
    }

    function getTotalQty() {
      return getLineItems().reduce(function(sum, item) { return sum + item.quantity; }, 0);
    }

    function getTierForQty(qty) {
      var tiers = state.tiers;
      var best = null;
      for (var i = 0; i < tiers.length; i++) {
        var t = tiers[i];
        if (t.sold_out) continue;
        if (qty >= (t.min || 0) && (t.max == null || qty <= t.max)) {
          if (!best || (t.percent != null && t.percent > (best.percent || 0))) best = t;
        }
      }
      return best;
    }

    function checkStockErrors() {
      var p = state.product;
      if (!p) return null;
      var isPreorder = (p.tags || []).indexOf('preorder') !== -1;
      if (isPreorder) return null;

      var qtyByVariant = {};
      if (!variantRows) return null;
      variantRows.querySelectorAll('.bulk-order-page__variant-row').forEach(function(row) {
        var select = row.querySelector('[data-variant-id]');
        var qtyInput = row.querySelector('[data-variant-qty]');
        var vid = select ? select.value : '';
        var qty = parseInt(qtyInput ? qtyInput.value : 0, 10);
        if (vid && qty > 0) {
          qtyByVariant[vid] = (qtyByVariant[vid] || 0) + qty;
        }
      });

      var errors = [];
      Object.keys(qtyByVariant).forEach(function(vid) {
        var v = getVariantStock(vid);
        if (!v) return;
        var requested = qtyByVariant[vid];
        if (v.available === false) {
          errors.push((v.option1 || v.title) + ' is sold out.');
        } else if (v.inventory_quantity !== undefined && v.inventory_quantity !== null && requested > v.inventory_quantity && v.inventory_management) {
          errors.push((v.option1 || v.title) + ': only ' + v.inventory_quantity + ' in stock (you entered ' + requested + ').');
        }
      });
      return errors.length > 0 ? errors.join(' ') : null;
    }

    function updateTotalAndButton() {
      var totalQty = getTotalQty();
      var tierForQty = getTierForQty(totalQty);
      var p = state.product;
      var basePrice = p && p.variants && p.variants[0] ? parseFloat(p.variants[0].price) : 0;

      highlightActiveTier(totalQty);

      if (totalLine) {
        if (totalQty === 0) {
          totalLine.textContent = 'Total: 0 items';
        } else {
          var percent = tierForQty && tierForQty.percent != null ? tierForQty.percent : 0;
          var pricePerUnit = basePrice * (1 - percent / 100);
          var totalCents = Math.round(pricePerUnit * totalQty * 100);
          var discountNote = percent > 0 ? ' <span class="bulk-order-page__total-discount">(' + percent + '% off applied)</span>' : '';
          totalLine.innerHTML = 'Total: ' + totalQty + ' item(s) — ' + formatMoney(totalCents) + discountNote;
        }
      }

      var stockError = totalQty > 0 ? checkStockErrors() : null;
      var valid = totalQty > 0 && !stockError;

      if (addToCartBtn) {
        addToCartBtn.disabled = !valid;
      }

      if (stockError) {
        showError(stockError);
      } else if (totalQty > 0 && state.tiers.length > 0 && !tierForQty) {
        var lowestMin = state.tiers.reduce(function(m, t) { return Math.min(m, t.min || 0); }, Infinity);
        showError('Add at least ' + lowestMin + ' items to unlock a bulk discount.');
      } else {
        showError('');
      }
    }

    function resetButton() {
      if (addToCartBtn) {
        addToCartBtn.textContent = 'Add to cart';
        addToCartBtn.disabled = false;
      }
    }

    function notifyCartUpdated() {
      try {
        if (typeof window.updateCart !== 'undefined') window.updateCart();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: {} }));
      } catch (e) {}

      fetch('/cart.json').then(function(r) { return r.json(); }).then(function(cart) {
        var count = cart.item_count || 0;
        document.querySelectorAll('.cart-count, [data-cart-count], .js-cart-count').forEach(function(el) {
          el.textContent = count;
        });
        var cartIcons = document.querySelectorAll('.header__cart-count, .cart-count-bubble span, [data-cart-item-count]');
        cartIcons.forEach(function(el) { el.textContent = count; });
      }).catch(function() {});
    }

    function updateTiersMap() {
      var productId = state.product && state.product.id;
      var tiers = state.tiers;
      if (!productId || !tiers || !tiers.length) return Promise.resolve();

      var productGid = 'gid://shopify/Product/' + productId;
      return fetch('/cart.json')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var prev = {};
          try {
            var raw = cart.attributes && cart.attributes._bulk_tiers_map;
            if (raw) prev = JSON.parse(raw);
          } catch (e) {}
          prev[productGid] = tiers;
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { _bulk_tiers_map: JSON.stringify(prev) } })
          });
        })
        .catch(function() {});
    }

    function doAddToCart() {
      var items = getLineItems();
      var merged = mergeLineItems(items);
      if (merged.length === 0) return;

      var stockErr = checkStockErrors();
      if (stockErr) {
        showError(stockErr);
        return;
      }

      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Adding…';
      showError('');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: merged })
      })
        .then(function(r) {
          if (r.status === 429) {
            throw new Error('Too many requests. Please wait a moment and try again.');
          }
          return r.text().then(function(text) {
            try { return JSON.parse(text); } catch (e) { throw new Error('Server error. Please try again.'); }
          });
        })
        .then(function(data) {
          if (data && (data.message || data.description)) {
            var errMsg = data.description || data.message || 'Could not add to cart.';
            if (/not enough/i.test(errMsg) || /inventory/i.test(errMsg) || /stock/i.test(errMsg)) {
              errMsg = 'Some items exceed available stock. Please reduce quantities and try again.';
            }
            showError(errMsg);
            resetButton();
            return;
          }
          return updateTiersMap().then(function() {
            resetButton();
            notifyCartUpdated();
            addToCartBtn.textContent = 'Added!';
            setTimeout(function() { addToCartBtn.textContent = 'Add to cart'; }, 2000);
          });
        })
        .catch(function(err) {
          showError(err.message || 'Could not add to cart. Please try again.');
          resetButton();
        });
    }

    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', doAddToCart);
    }

    if (variantsToggle) {
      variantsToggle.addEventListener('click', function() {
        var expanded = variantsWrap.getAttribute('aria-hidden') !== 'true';
        variantsWrap.setAttribute('aria-hidden', expanded ? 'true' : 'false');
        variantsToggle.setAttribute('aria-expanded', !expanded);
        variantsToggle.textContent = expanded ? 'Show' : 'Hide';
      });
    }

    var tabsScroll = container.querySelector('[data-tabs-scroll]');
    var tabsPrev = container.querySelector('[data-tabs-prev]');
    var tabsNext = container.querySelector('[data-tabs-next]');

    function updateTabArrows() {
      if (!tabsScroll) return;
      var sl = tabsScroll.scrollLeft;
      var maxScroll = tabsScroll.scrollWidth - tabsScroll.clientWidth;
      if (tabsPrev) tabsPrev.disabled = sl <= 2;
      if (tabsNext) tabsNext.disabled = sl >= maxScroll - 2;
      var needsArrows = tabsScroll.scrollWidth > tabsScroll.clientWidth + 2;
      if (tabsPrev) tabsPrev.style.display = needsArrows ? '' : 'none';
      if (tabsNext) tabsNext.style.display = needsArrows ? '' : 'none';
    }

    if (tabsPrev) {
      tabsPrev.addEventListener('click', function() {
        if (tabsScroll) tabsScroll.scrollLeft -= 150;
      });
    }
    if (tabsNext) {
      tabsNext.addEventListener('click', function() {
        if (tabsScroll) tabsScroll.scrollLeft += 150;
      });
    }
    if (tabsScroll) {
      tabsScroll.addEventListener('scroll', updateTabArrows);
      window.addEventListener('resize', updateTabArrows);
      updateTabArrows();
    }

    container.querySelectorAll('.bulk-order-page__collection-tab').forEach(function(tab) {
      tab.addEventListener('click', function() {
        var handle = tab.getAttribute('data-collection-handle');
        var title = tab.getAttribute('data-collection-title');
        if (handle) {
          activateTab(tab);
          loadCollectionProducts(handle, title);
        }
      });
    });

    var firstTab = container.querySelector('.bulk-order-page__collection-tab.is-active');
    if (firstTab) {
      var handle = firstTab.getAttribute('data-collection-handle');
      var title = firstTab.getAttribute('data-collection-title');
      if (handle) loadCollectionProducts(handle, title);
    } else {
      setEmpty(true);
    }

    // If URL has ?product=handle, pre-select that product (e.g. from PDP "Order in bulk & save" button)
    var productParam = (function() {
      try {
        var params = new URLSearchParams(window.location.search);
        return params.get('product') || params.get('product_handle') || '';
      } catch (e) {
        var m = window.location.search.match(/[?&]product(?:[_\-]?handle)?=([^&]+)/);
        return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : '';
      }
    })();
    if (productParam) {
      setTimeout(function() {
        selectProduct(productParam);
      }, 300);
    }
  }

  window.initBulkOrderPage = initBulkOrderPage;
})();
